import { computed, ComputedRef } from 'vue'
import { useRoute } from 'vue-router'

export function useIsPublicDashboardView(): ComputedRef {
    const route = useRoute()

    return computed(() => route.name === 'dashboards.show-public')
}
